import { Switch } from '@base-ui/react/switch';
import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
export const Root = styled(Switch.Root) `
  --switch-height: ${(p) => pxToRem(p.$radii)};
  --switch-width: ${(p) => pxToRem(p.$radii * 2)};

  flex-shrink: 0;
  width: var(--switch-width);
  height: var(--switch-height);
  padding: ${pxToRem(2)};
  background-color: ${themeGet('colors.primary.200')};
  border-radius: var(--switch-height);
  position: relative;
  -webkit-tap-highlight-color: rgb(0 0 0 / 0%);
  transition: all 300ms;

  &[data-checked] {
    background-color: black;
  }

  &[data-disabled] {
    opacity: 0.5;
  }
`;
export const Handle = styled(Switch.Thumb) `
  --handle-spacing: ${pxToRem(2)};
  --handle-radii: calc(${(p) => pxToRem(p.$radii)} - var(--handle-spacing) * 2);

  display: block;
  width: var(--handle-radii);
  height: var(--handle-radii);
  background-color: ${themeGet('colors.gray.0')};
  border-radius: ${themeGet('borderRadius.circle')};
  box-shadow: 0 ${pxToRem(2)} ${pxToRem(5)} rgb(0 0 0 / 15%);
  transition: transform 300ms ease-in-out;
  transform: translateX(0%);
  will-change: transform;

  &[data-checked] {
    transform: translateX(calc(100% + var(--handle-spacing) * 2));
  }
`;
